import React, { Component } from "react";
import "../App.css";
import MeditationBanner from "../images/Meditation/meditation-banner.png";
import CloseArrow from "../images/close_arrow.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class MeditationIsKey extends Component {
  state = {
    bookList: [
      {
        id: 1,
        title: "The Power of Letting Go",
        author: "John Purkiss",
        preview:
          "The Power of Letting Go divulges core concepts for anyone seeking personal development and self discovery. For many people it's hard to let go and others the task is so easy. The reader must choose to overcome fear and anxiety in order to become a new person and achieve new goals.",
      },
      {
        id: 2,
        title: "Wherever You Go, There You Are",
        author: "Jon Kabat-Zinn",
        preview:
          "Written in 1994, the book is still a nationwide bestseller; continuing to change lives. Mindfulness makes you “pay attention”; without being judgemental of your own thoughts, desires and mistakes.",
      },
      {
        id: 3,
        title: "The Illuminated Mind",
        author: "John Yates",
        preview:
          "The book that bestselling meditation teacher Sharon Salzberg raves “brings the path of meditation to life,” The Mind Illuminated is the first how-to meditation guide from a neuroscientist who is also an acclaimed meditation master.",
      },
      {
        id: 4,
        title: "Breath",
        author: "James Nestor",
        preview:
          "There is nothing more essential to our health and well-being than breathing: Take air in, let it out, repeat 25,000 times a day. Yet, as a species, humans have lost the ability to breathe correctly, with grave consequences. Journalist James Nestor travels the world to figure out what went wrong and how to fix it.",
      },
      {
        id: 5,
        title: "The Code of the Extraordinary Mind",
        author: "Vishen Lakhiani",
        preview:
          "In a unique fusion of cutting-edge ideas, personal stories, irreverence, and his brilliant teaching style, Lakhiani reveals the 10 powerful laws that form a step-by-step process that you can apply to life to shed years of struggle and elevate yourself to exceptional new heights.",
      },
      {
        id: 6,
        title: "The Buddha and the Badass",
        author: "Vishen Lakhiani",
        preview:
          "Once you integrate the skill sets of both archetypes, you will experience life at a different level from most people. You will operate from a space of bliss, ease, inspiration, and abundance. The Buddha and the Badass: The Secret Spiritual Art of Succeeding at Work will show you how.",
      },
      {
        id: 7,
        title: "Everyday Happiness Mantras",
        author: "Dr. Rekha Shetty",
        preview:
          "Everyday Happiness Mantras, your very own guidebook to good cheer, will stay with you through the annual calendar and constantly remind you of the things that truly matter in life.",
      },
      {
        id: 8,
        title: "Think Like a Monk",
        author: "Jay Shetty",
        preview:
          "Think Like a Monk reveals how to overcome negative thoughts and habits and access the calm and purpose that lie within all of us. He transforms abstract lessons into advice and exercises we can all apply to reduce stress, improve relationships, and give the gifts we find in ourselves to the world.",
      },
    ],
  };

  handleBook1Click = () => {
    document
      .getElementById("bump-out-1")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook2Click = () => {
    document
      .getElementById("bump-out-2")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook3Click = () => {
    document
      .getElementById("bump-out-3")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook4Click = () => {
    document
      .getElementById("bump-out-4")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook5Click = () => {
    document
      .getElementById("bump-out-5")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook6Click = () => {
    document
      .getElementById("bump-out-6")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook7Click = () => {
    document
      .getElementById("bump-out-7")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook8Click = () => {
    document
      .getElementById("bump-out-8")
      .classList.toggle("bump-out-slide-left");
  };

  render() {
    return (
      <div>
        <section className="time-banner-wrapper">
          <img
            className="Time-Banner"
            src={MeditationBanner}
            alt="meditation banner"
          ></img>
          <div>
            <h1>Meditation is Key</h1>
            <p>
              Be here now. Be someplace else later. Sooth your mind through
              meditation
            </p>
          </div>
        </section>
        <section className="time-grid-container">
          <div className="grid-title">
            <h1>Popular Titles</h1>
            <input type="search" placeholder="search titles"></input>
          </div>

          {/* Book 1 */}
          <div className="bumpout-animation-wrapper book-1-position">
            <div id="bump-out-1" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[0].title}</h2>
                <h2>Author: {this.state.bookList[0].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[0].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook1Click}
              />
            </div>
            <div
              className="meditation-book1-cover book1-style"
              onClick={this.handleBook1Click}
            ></div>
          </div>

          {/* Book 2 */}
          <div className="bumpout-animation-wrapper book-2-position">
            <div id="bump-out-2" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[1].title}</h2>
                <h2>Author: {this.state.bookList[1].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[1].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook2Click}
              />
            </div>
            <div
              className="meditation-book2-cover book2-style"
              onClick={this.handleBook2Click}
            ></div>
          </div>

          {/* Book 3 */}
          <div className="bumpout-animation-wrapper book-3-position">
            <div id="bump-out-3" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[2].title}</h2>
                <h2>Author: {this.state.bookList[2].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[2].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook3Click}
              />
            </div>
            <div
              className="meditation-book3-cover book3-style"
              onClick={this.handleBook3Click}
            ></div>
          </div>

          {/* Book 4 */}
          <div className="bumpout-animation-wrapper book-4-position">
            <div id="bump-out-4" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[3].title}</h2>
                <h2>Author: {this.state.bookList[3].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[3].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook4Click}
              />
            </div>
            <div
              className="meditation-book4-cover book4-style"
              onClick={this.handleBook4Click}
            ></div>
          </div>

          {/* Book 5 */}
          <div className="bumpout-animation-wrapper book-5-position">
            <div id="bump-out-5" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[4].title}</h2>
                <h2>Author: {this.state.bookList[4].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[4].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook3Click}
              />
            </div>
            <div
              className="meditation-book5-cover book5-style"
              onClick={this.handleBook5Click}
            ></div>
          </div>

          {/* Book 6 */}
          <div className="bumpout-animation-wrapper book-6-position">
            <div id="bump-out-6" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[5].title}</h2>
                <h2>Author: {this.state.bookList[5].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[5].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook4Click}
              />
            </div>
            <div
              className="meditation-book6-cover book6-style"
              onClick={this.handleBook6Click}
            ></div>
          </div>

          {/* Book 7 */}
          <div className="bumpout-animation-wrapper book-7-position">
            <div id="bump-out-7" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[6].title}</h2>
                <h2>Author: {this.state.bookList[6].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[6].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook7Click}
              />
            </div>
            <div
              className="meditation-book7-cover book7-style"
              onClick={this.handleBook7Click}
            ></div>
          </div>

          {/* Book 8 */}
          <div className="bumpout-animation-wrapper book-8-position">
            <div id="bump-out-8" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[7].title}</h2>
                <h2>Author: {this.state.bookList[7].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[7].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook8Click}
              />
            </div>
            <div
              className="meditation-book8-cover book8-style"
              onClick={this.handleBook8Click}
            ></div>
          </div>
        </section>
      </div>
    );
  }
}

export default MeditationIsKey;
